export default __webpack_public_path__ + "images/models/4895852f0f4dfa2c9084ad26f12c84f0.usdz";